export default __webpack_public_path__ + "static/media/blob_top.0eedfd1c.svg";